import { BaseCircle, Circle } from './circle';
/**
 * ○
 */
export const HollowCircle = (options, context) => {
    return BaseCircle(Object.assign({ colorAttribute: 'stroke' }, options), context);
};
HollowCircle.props = Object.assign({ defaultMarker: 'hollowPoint' }, Circle.props);
//# sourceMappingURL=hollowCircle.js.map